import React from 'react';
import PropTypes from 'prop-types';
import { FDPaper } from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const ShadowBox = ({ children, className }) => (
  <Box className={className} marginBottom={2}><FDPaper padding={2} height="100%">{children}</FDPaper></Box>
);

ShadowBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ShadowBox.defaultProps = {
  children: null,
  className: undefined,
};

export default ShadowBox;
